export const userStatuses = [
    {
        value: false,
        text: 'active',
    },
    {
        value: true,
        text: 'inactive',
    }
];